"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = SkeletonCard;

var _react = _interopRequireDefault(require("react"));

require("./skeleton.scss");
/* eslint-disable jsx-a11y/heading-has-content */


function SkeletonCard() {
  return _react["default"].createElement("div", {
    className: "skeleton-container"
  }, _react["default"].createElement("section", {
    className: "skeleton-card"
  }, _react["default"].createElement("figure", {
    className: "skeleton-card-image skeleton-loading"
  }), _react["default"].createElement("div", {
    className: "skeleton-card-detail"
  }, _react["default"].createElement("h3", {
    className: "skeleton-card-title skeleton-loading"
  }), _react["default"].createElement("p", {
    className: "skeleton-card-description  skeleton-loading"
  }))));
}